// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

export const FETCH_DOMAINS = 'fetch_domains'

export function fetchDomains () {
  return (dispatch, getState) => {
    const {domainManagement} = getState()
    let domains = domainManagement.domains || []
    dispatch({
      type: FETCH_DOMAINS,
      payload: {
        domains: domains
      }
    })
  }
}
